<template>
  <div class="image props-group">
    <el-form-item label="幻灯片显示">
      <el-checkbox v-model="component.properties.slideModel" @change="$emit('update', 'image')"></el-checkbox>
    </el-form-item>
    <div class="image-list">
      <el-form-item v-for="(img,i) in imageList" :key="img.id" :label="'图片' + (i + 1)">
        <el-upload
          action=""
          :before-upload="(file) => beforeUpload(file, img.id)"
          :http-request="(file) => uploadImage(file, img.id)"
          :show-file-list="false"
          :data="dataType">
          <el-input slot="trigger" :class="{'has-image':img.src}" :value="img.loding ? '上传中...': img.name || '上传图片'" readonly>
            <i slot="suffix" class="el-icon-error el-input__icon" @click.stop="deleteSelectImage(img.id)"></i>
          </el-input>
          <i class="el-icon-delete" @click="deleteImage(img.id)"></i>
        </el-upload>
      </el-form-item>
      <div class="rc-image-add" @click="addImage"><i class="el-icon-plus">添加图片</i></div>
    </div>
  </div>
</template>

<script>
import { ossMixin } from '../runtime/components/mixins'
import { UUID } from '@/plugins/common'

export default {
  name: 'attr-image',
  props: ['component'],
  mixins: [ossMixin],
  data () {
    return {
      dataType: {type: 'USER'},
      imageList: [],
      uploadingRequest: []
    }
  },
  created () {
    // 从属性中取出已上传的图片信息, 并赋上id作为标识
    if (this.component.properties.imageList.length !== 0 && this.imageList.length === 0) {
      this.imageList = this.component.properties.imageList.map(img => {
        return {
          id: UUID.create(),
          name: img.name,
          src: img.src,
          loading: false
        }
      })
    } else {
      this.imageList.push({
        id: UUID.create(),
        name: '',
        src: '',
        loading: false
      })
    }
  },
  methods: {
    beforeUpload (file, id) {
      let currentUploadImage = this.imageList.find(img => img.id === id)

      if (!currentUploadImage) {
        this.$message.warning('未找到图片')
        return false
      }
      if (currentUploadImage.src) {
        this.$message.warning('请先删除原图片再上传')
        return false
      }
      if (currentUploadImage.loading) {
        // 取消上传
        this.cancelUpload(id)
      }
      let type = file.name.split('.').pop()
      // 只允许上传图片
      let allowType = ['png', 'jpg', 'jpeg', 'gif']
      if (!allowType.some(n => n === type.toLocaleLowerCase())) {
        this.$message.warning('图片展示控件只能上传图片')
        return false
      }
      if (file.size > 50 * 1024 * 1024) {
        this.$message.warning('图片超出50M大小限制')
        return false
      }
      currentUploadImage.loading = true
    },
    // 上传图片
    uploadImage (files, id) {
      const CancelToken = this.$axios.CancelToken
      let file = files.file
      let key = this.getOssKey('USER', file.name)
      let url = sessionStorage.getItem('ossDownloadUrl')
      let formData = this.getUploadFormData(key, file)
      let _this = this
      this.$axios.post(url, formData, {
        headers: {'Content-Type': 'multipart/form-data'},
        cancelToken: new CancelToken(function excutor (c) {
          _this.uploadingRequest.push({id, cancelUpload: c})
        })
      }).then(res => {
        res.status === 200 ? this.updateFile(this.getResult(key, file.name), file, id) : this.uploadFailed(file, id)
      })
    },
    // 上传成功
    updateFile (res, file, id) {
      let currentUploadImage = this.imageList.find(img => img.id === id)
      if (currentUploadImage) {
        currentUploadImage.src = res[0].result.dir
        currentUploadImage.name = res[0].result.file
        currentUploadImage.loading = false
      }
      this.updateProperties()
    },
    // 上传失败
    uploadFailed (file, id) {
      let currentUploadImage = this.imageList.find(img => img.id === id)
      currentUploadImage.loading = false
      this.$message.error(`${file.name} 上传失败，请重新上传`)
    },
    // 更新属性
    updateProperties () {
      this.component.properties.imageList = this.imageList.map(img => {
        return {
          name: img.name || '',
          src: img.src || ''
        }
      })
      // 实时保存
      this.$emit('update', 'image')
    },
    // 取消上传
    cancelUpload (id) {
      this.uploadingRequest.find(e => e.id === id) && this.uploadingRequest.find(e => e.id === id).cancelUpload()
    },
    // 添加图片
    addImage () {
      this.imageList.push({
        id: UUID.create(),
        name: '',
        src: '',
        loading: false
      })
      this.updateProperties()
    },
    // 删除当前选项的图片
    deleteSelectImage (id) {
      let currentUploadImage = this.imageList.find(img => img.id === id)
      if (currentUploadImage.loading) {
        this.cancelUpload(id)
      }
      currentUploadImage.name = ''
      currentUploadImage.src = ''
      this.updateProperties()
    },
    // 删除图片
    deleteImage (id) {
      let currentUploadImage = this.imageList.find(img => img.id === id)
      if (currentUploadImage.loading) {
        this.cancelUpload(id)
      }
      this.imageList = this.imageList.filter(img => img.id !== id)
      this.updateProperties()
    }
  }
}
</script>
<style lang="scss">
  .image.props-group{
    .el-form-item{
      .el-checkbox .el-checkbox__inner{
        background-color: #ffffff;
        border: 1px solid #DCDFE6;
        &::after{
          border: 1px solid #409EFF;
          border-left: 0;
          border-top: 0;
        }
      }
    }
    .image-list{
      border-top: 1px solid #EBEBEB;
      .el-input:not(.has-image) input{
        cursor: pointer;
        color: #54ABF1;
      }
      .el-form-item .el-form-item__content{
        .el-upload.el-upload--text{
          width: calc(100% - 20px);
          .el-icon-error,.el-icon-delete{
            &:hover {
              color: #FB9391;
            }
            &:active {
              color: #EE5451;
            }
          }
        }
        .el-icon-delete{
          cursor: pointer;
          &:hover {
            color: #FB9391;
          }
          &:active {
            color: #EE5451;
          }
        }
      }
    }
    .rc-image-add{
      cursor: pointer;
      text-align: center;
      padding-top: 6px;
      color: #54ABF1;
      .el-icon-plus{
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/image.vue